<template>
  <el-aside width="11.6vw" style="background-color: rgb(255, 255, 255); position: fixed; top: 45px; left: 0; bottom: 0; z-index: 999;">
    <div class="logo">
      <!-- <img src="@/assets/icons/logo@3x.png" alt="泛亚人力" class="logo_img" /> -->
      <!-- <div class="logo_img"></div> -->
    </div>
    <el-menu
      unique-opened
      router
      :default-active="route.meta.hignlightNavPath || route.path"
      @select="select"
      active-text-color="#f26828"
      style="height: calc(100% - 60px); overflow-y: auto;"
    >
      <el-menu-item index="/home" @click.native="refresh('/home')">
        <span class="nav-icon nav-icon-home"></span>主页
      </el-menu-item>
      <!-- <el-menu-item index="/">
        <i class="el-icon-message"></i>数据中心
      </el-menu-item>-->
      <el-submenu index="1">
        <template slot="title">
          <span class="nav-icon nav-icon-employee"></span>员工档案
        </template>
        <el-menu-item-group>
          <el-menu-item index="/EmployeeInfo"  @click.native="refresh('/EmployeeInfo')">
            <span class="nav-icon nav-icon-common"></span>员工信息
          </el-menu-item>
          <el-menu-item index="/EmployeeContract"  @click.native="refresh('/EmployeeContract')"> 
            <span class="nav-icon nav-icon-common"></span>员工合同
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/SocialSecurity" @click.native="refresh('/SocialSecurity')">
        <span class="nav-icon nav-icon-social"></span>社保公积金
      </el-menu-item>
      <el-submenu index="2">
        <template slot="title">
          <span class="nav-icon nav-icon-salary"></span>薪资档案
        </template>
        <el-menu-item-group>
          <el-menu-item index="/SalaryBatches" @click.native="refresh('/SalaryBatches')">
            <span class="nav-icon nav-icon-common"></span>薪资批次
          </el-menu-item>
          <el-menu-item index="/SalaryDetails" @click.native="refresh('/SalaryDetails')">
            <span class="nav-icon nav-icon-common"></span>薪资详情
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-submenu index="3">
        <template slot="title">
          <span class="nav-icon nav-icon-charts"></span>报表中心
        </template>
        <el-menu-item-group>
          <el-menu-item index="/EmploymentData"  @click.native="refresh('/EmploymentData')">
            <span class="nav-icon nav-icon-common"></span>员工数据报表
          </el-menu-item>
          <el-menu-item index="/SocialSecurityData"  @click.native="refresh('/SocialSecurityData')">
            <span class="nav-icon nav-icon-common"></span>社保数据报表
          </el-menu-item>
          <el-menu-item index="/SalaryData"  @click.native="refresh('/SalaryData')">
            <span class="nav-icon nav-icon-common"></span>薪酬数据报表
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      <el-menu-item index="/Policy"  @click.native="refresh('/Policy')">
        <span class="nav-icon nav-icon-policy" ></span>政策公告
      </el-menu-item>
      <el-menu-item index="/UserInfo"  @click.native="refresh('/UserInfo')">
        <svg class="nav-icon nav-icon-userinfo" viewBox="0 0 1024 1024" width="20" height="20">
          <path d="M352 288h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64zM352 416h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64zM352 544h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64zM352 672h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64zM544 288h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64zM544 416h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64zM544 544h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64zM544 672h-64a32 32 0 0 0 0 64h64a32 32 0 0 0 0-64z"></path>
          <path d="M960 864h-64v-576a64 64 0 0 0-64-64h-128v-64a64 64 0 0 0-64-64H192a64 64 0 0 0-64 64v704H64a32 32 0 0 0 0 64h896a32 32 0 0 0 0-64z m-768 0v-704h448v704H192z m512 0v-576h128v576h-128z"></path>
        </svg>企业信息
      </el-menu-item>
      <el-submenu index="4">
        <template slot="title">
          <span class="nav-icon nav-icon-message"></span>通知提醒
        </template>
        <el-menu-item-group>
          <el-menu-item index="/Message"  @click.native="refresh('/Message')">
            <span class="nav-icon nav-icon-common"></span>通知提醒详情
          </el-menu-item>
          <el-menu-item index="/MessageSettings"  @click.native="refresh('/MessageSettings')">
            <span class="nav-icon nav-icon-common"></span>通知提醒设置
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </el-menu>
  </el-aside>
</template>

<script>
import $ from "jquery";
export default {
  data() {
    return {};
  },
  computed: {
    route() {
      return this.$store.state.route;
    }
  },
  methods: {
    select() {},
    deal_css() {
      $(function() {
        $(".el-menu-item-group__title").css({ padding: 0 });
      });
    },
    // 点击当前页面导航时刷新页面，存在bug使切换页面时也刷新
    refresh() {
      
      // if(path === this.$route.path) {
      //   this.$router.go(0);
      //   document.documentElement.scrollTop = 0
      // }
    }
  },
  mounted() {
    this.deal_css();
  }
};
</script>

<style lang="scss" scoped>
.el-aside {
  border-right: 1px solid #d5d6de;
}
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 40px;
}
.logo_img {
  /* background-color: orange; */
  width: 115px;
  height: 50px;
}
.el-menu {
  border-right: none;
}
.el-submenu {
  text-align: left;
}
.el-menu-item {
  text-align: left;
}
.el-menu-item-group .el-menu-item-group__title {
  padding: 0;
}
.el-submenu .el-menu-item {
  padding: 0 20px;
}
.el-menu-item.is-active::after {
  position: absolute;
  height: 18px;
  width: 1px;
  right: 0;
  top: 16px;
  /* border-right: 1px solid orange; */
}

.nav-icon {
  display: inline-block;
  width: 24px;
  height: 18px;
  margin-right: 5px;
}
.nav-icon-home {
  background: url("../assets/icons/homepage-default@2x.png") center center / 18px 17px
    no-repeat;
}
.nav-icon-employee {
  background: url("../assets/icons/employee_menu_icon.png") center center / 19px 16px
    no-repeat;
}
.nav-icon-social {
  background: url("../assets/icons/social_menu_icon.png") center center / 20px 16px
    no-repeat;
}
.nav-icon-salary {
  background: url("../assets/icons/salary_menu_icon.png") center center / 19px 16px
    no-repeat;
}
.nav-icon-charts {
  background: url("../assets/icons/Reportcenter-default@2x.png") center center / 18px 17px
    no-repeat;
}
.nav-icon-policy {
  background: url("../assets/icons/announcement-default@2x.png") center center / 18px 18px
    no-repeat;
}
.nav-icon-message {
  background: url("../assets/icons/bell001-E104@2x.png") center center  / 16px 18px no-repeat;
  opacity: 0.6;
}
.nav-icon-common {
  background: url("../assets/icons/circle-default@2x.png") center center / 10px 10px
    no-repeat;
}
.nav-icon-userinfo {
  fill: #606266;
}
// 选中的导航的图标
.el-menu-item.is-active::after {
  .nav-icon-home {
    background: url("../assets/icons/homepage-Selection@2x.png") center center / 18px 17px
      no-repeat;
  }
  .nav-icon-employee {
    background: url("../assets/icons/employee_menu_icon_active.png") center
      center  / 19px 16px no-repeat;
  }
  .nav-icon-social {
    background: url("../assets/icons/social_menu_icon_active.png") center center / 20px 16px
      no-repeat;
  }
  .nav-icon-salary {
    background: url("../assets/icons/salary_menu_icon_active.png") center center / 19px 16px
      no-repeat;
  }
  .nav-icon-charts {
    background: url("../assets/icons/Reportcenter-Selection@2x.png") center
      center / 18px 17px no-repeat;
  }
  .nav-icon-policy {
    background: url("../assets/icons/announcement-Selection@2x.png") center
      center / 18px 18px no-repeat;
  }
  .nav-icon-common {
    background: url("../assets/icons/circle-Selection@2x.png") center center / 10px 10px
      no-repeat;
  }
  .nav-icon-userinfo {
    fill: #f26828;
  }
}
</style>